module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/passthrough.js
// module id = ./node_modules/readable-stream/passthrough.js
// module chunks = 0